export const SETUP_INIT_DATA = 'SETUP_INIT_DATA';
export const FETCH_DATA = 'FETCH_DATA';
export const VIEW = 'VIEW';
export const SET_LOADING = 'SET_LOADING';
